/*
 * ******************************************************************
 * Copyright (c) 2023-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { Component, Input, Output } from "@angular/core";
import { Subject } from "rxjs";

//@formatter:off
@Component({
    standalone: false,
    selector: 'global-error',
    templateUrl: 'global-error.component.html',
    styleUrls: ['global-error.component.scss']
})
//@formatter:on
export class GlobalErrorComponent {

    @Input()
    errorMsg: string;

    @Input()
    errorBtn: string;

    @Input()
    closable: boolean = false;

    @Output()
    errorBtnClick: Subject<void> = new Subject<void>();

    onErrorButtonClick(): void {
        this.errorBtnClick.next();
    }
}
